import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

interface ExternalAccessBannerProps {
  className?: string;
}

export const ExternalAccessBanner: React.FC<ExternalAccessBannerProps> = ({ className }) => {
  return (
    <div
      role="status"
      className={`flex items-start sm:items-center gap-3 p-3.5 rounded-md bg-blue-50 border border-blue-200 text-blue-900 ${className ?? ''}`}
    >
      <MdInfoOutline className="text-blue-600 flex-shrink-0 text-xl mt-0.5 sm:mt-0" />
      <div>
        <span className="font-semibold text-sm">External User Access: </span>
        <span className="text-sm text-blue-800">
          You are currently signed in with an External role. Access is restricted to assigned projects in read-only mode, except for submitting UAT test results.
        </span>
      </div>
    </div>
  );
};
